import { ScorechainConnector } from "./lib/scorechainConnector";
import { ScoringAnalysisType, ScoringObjectType, SeverityEnum } from "./types/scoringAnalysis";
import {
    Transaction,
    ScoringAnalysis,
    FeedWithdrawal,
    Address,
    BlockchainEnum,
    ScorechainError,
    TransactionTypeEnum,
} from "./types";
import { proofOfAuthenticityVerifierAdapterForAxios, proofOfAuthenticityVerifier } from "./utils/proofOfAuthenticityVerifier";

export {
    ScorechainConnector,
    BlockchainEnum,
    TransactionTypeEnum,
    ScoringObjectType,
    ScoringAnalysisType,
    Transaction,
    ScoringAnalysis,
    FeedWithdrawal,
    Address,
    ScorechainError,
    SeverityEnum,
    proofOfAuthenticityVerifierAdapterForAxios,
    proofOfAuthenticityVerifier,
};
